import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import {
  MDBModalRef,
  MDBModalService,
  ToastService
} from "ng-uikit-pro-standard";
import { ConfirmCityComponent } from "../../popups/confirm-city/confirm-city.component";
import { City } from "src/app/core/city/city.model";
import { AppService } from "src/app/core/app/app.service";
import * as firebase from "firebase";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
@Component({
  selector: "ll-add-city-form",
  templateUrl: "./add-city-form.component.html",
  styleUrls: ["./add-city-form.component.scss"]
})
export class AddCityFormComponent implements OnInit {
  private city: City;
  public image: string;
  public bannerImage: string;
  public title: string;
  public button: string;
  public totalActiveVenues: number = 0;
  public usingCoordinates: boolean = false;

  public form: FormGroup;

  constructor(
    public app: AppService,
    public modalRef: MDBModalRef,
    private modalService: MDBModalService,
    private toast: ToastService
  ) {}

  ngOnInit() {
    if (this.city != null) this.edit();
    else this.add();
  }

  shouldShowMoveCityCreation() {
    return this.app.state.permissions.includes(environment.moveCityCreation);
  }

  onClickDashboardRedirect() {
    window.location.href = `${environment.ticketingDashboardBaseURL}/dashboard/city`;
  }


  add() {
    this.form = new FormGroup({
      name: new FormControl(""),
      state: new FormControl(""),
      isActive: new FormControl(true),
      isBannerActive: new FormControl(false),
      bannerText: new FormControl(""),
      bannerImage: new FormControl(""),
      isBannerRedirectActive: new FormControl(false),
      bannerRedirectUrl: new FormControl(""),

      redirect: new FormControl(false),
      redirectUrl: new FormControl(""),

      image: new FormControl(""),
      latitude: new FormControl(),
      longitude: new FormControl()
    });
    this.totalActiveVenues = 0;
    this.bannerImage = "";
    this.image = "";
    this.title = "Add City";
    this.button = "Add";
  }

  edit() {
    this.form = new FormGroup({
      name: new FormControl(this.city.name),
      state: new FormControl(this.city.state),
      isBannerActive: new FormControl(this.city.isBannerActive),
      bannerText: new FormControl(this.city.bannerText),
      bannerImage: new FormControl(this.city.bannerImage),
      isActive: new FormControl(this.city.isActive),
      image: new FormControl(this.city.image),

      isBannerRedirectActive: new FormControl(this.city.isBannerRedirectActive),
      bannerRedirectUrl: new FormControl(this.city.bannerRedirectUrl),
      redirect: new FormControl(this.city.redirect),
      redirectUrl: new FormControl(this.city.redirectUrl),

      latitude: new FormControl(this.city.coordinates.latitude),
      longitude: new FormControl(this.city.coordinates.longitude)
    });
    this.totalActiveVenues = this.city.totalActiveVenues;

    this.image = this.city.image;
    this.bannerImage = this.city.bannerImage;
    this.title = "Edit City";
    this.button = "Save";
  }

  imageSelected = (): boolean => this.image != "";

  bannerSelected = (): boolean => this.bannerImage != "";

  get bannerRedirectUrl(): string {
    return this.form.controls.bannerRedirectUrl.value;
  }

  get redirectUrl(): string {
    return this.form.controls.redirectUrl.value;
  }

  get isBannerRedirectActive(): boolean {
    return this.form.controls.isBannerRedirectActive.value;
  }

  get redirect(): boolean {
    return this.form.controls.redirect.value;
  }

  get bannerText(): string {
    return this.form.controls.bannerText.value;
  }
  get isBannerActive(): boolean {
    return this.form.controls.isBannerActive.value;
  }
  get name(): string {
    return this.form.controls.name.value;
  }

  get state(): string {
    return this.form.controls.state.value;
  }

  get isActive(): boolean {
    return this.form.controls.isActive.value;
  }

  get latitude(): number {
    return this.form.controls.latitude.value;
  }

  get longitude(): number {
    return this.form.controls.longitude.value;
  }

  get geopoint(): firebase.firestore.GeoPoint {
    return new firebase.firestore.GeoPoint(this.latitude, this.longitude);
  }

  public get cities$(): Observable<City[]> {
    return this.app.state.cities$;
  }

  async validate(cities: City[]) {
    if (
      this.city == null &&
      cities
        .map(city => city.name + city.state)
        .includes(this.name + this.state)
    )
      return this.toast.error(
        "The provided city already exists!",
        "Duplicate City",
        {
          opacity: 1
        }
      );

    if (this.state == "")
      return this.toast.error("Please select a state!", "No state selected", {
        opacity: 1
      });

    if (this.image == "")
      return this.toast.error(
        "Please provide an image for the city!",
        "No Thumbnail Provide",
        { opacity: 1 }
      );
    if (!this.usingCoordinates) {
      let geo = await this.app.fb.getGeopoint(this.name, this.state);
      if (geo == null || !this.isValid(this.name.toLowerCase())) {
        this.usingCoordinates = true;
        if (this.latitude == null || this.longitude == null) {
          return this.toast.warning(
            "It looks like we couldn't find the city you have provided. Please enter the latitude/longitude coordinates",
            "Invalid Geolocation",
            { opacity: 1 }
          );
        } else {
        }
      }
    } else {
      if (!this.isValidCoordinates()) {
        return this.toast.error(
          "The coordinates provided are invalid, please try again. Example Coordinate: '-40.798989'",
          "Geopoint Error",
          { opacity: 1 }
        );
      }
    }

    //Step 5: Have user confirm if editing city with active venues
    if (!this.isActive && this.totalActiveVenues > 0) return this.confirm();
    else return this.submit();
  }

  isValidCoordinates() {
    let lonFlag: boolean = /^-{0,1}((180|180.[0]{1,20}|[0-9]|([0-9][0-9])|([1][0-7][0-9]))|(179|[0-9]|([0-9][0-9])|([1][0-7][0-9]))[.]{1}[0-9]{1,20}){1}$/.test(
      this.longitude.toString()
    );
    let latFlag: boolean = /^-{0,1}((90|90.[0]{1,20}|[0-9]|[1-8][0-9])|(89|[0-9]|[1-8][0-9])[.]{1}[0-9]{1,20}){1}$/.test(
      this.latitude.toString()
    );
    return lonFlag && latFlag;
  }

  isValid(input: string) {
    return /^[a-z][a-z\s]*$/.test(input);
  }

  confirm() {
    this.modalRef.hide();
    this.modalRef = this.modalService.show(ConfirmCityComponent, {
      ignoreBackdropClick: true,
      class: "modal-dialog-centered",
      containerClass: "",
      animated: true,
      data: {
        active_venues: this.totalActiveVenues
      }
    });
    this.modalRef.content.action.subscribe((result: boolean) => {
      if (result) {
        this.submit();
      }
    });
  }

  error(msg: string) {
    this.toast.error(msg, "City Creation Error", { opacity: 1 });
  }

  async submit() {
    const coordinates = this.usingCoordinates
      ? this.geopoint
      : await this.app.fb.getGeopoint(this.name, this.state);
    const timezone = await this.app.fb.getTimezone(coordinates);
    this.app.state.cityBuilder.name = this.name;
    this.app.state.cityBuilder.state = this.state;
    this.app.state.cityBuilder.isActive = this.isActive;
    this.app.state.cityBuilder.bannerImage = this.bannerImage;
    this.app.state.cityBuilder.bannerText = this.bannerText;
    this.app.state.cityBuilder.isBannerActive = this.isBannerActive;
    this.app.state.cityBuilder.image = this.image;
    this.app.state.cityBuilder.coordinates = coordinates;
    this.app.state.cityBuilder.timezone = timezone;
    this.app.state.cityBuilder.bannerRedirectUrl = this.bannerRedirectUrl;
    this.app.state.cityBuilder.isBannerRedirectActive = this.isBannerRedirectActive;
    this.app.state.cityBuilder.redirect = this.redirect;
    this.app.state.cityBuilder.redirectUrl = this.redirectUrl;

    await this.app.state.onSaveCityPressed(this.app.state.cityBuilder.build());

    this.modalRef.hide();

    this.toast.success("City Updated!", "Success", { opacity: 1 });
  }

  async selectImage(event) {
    this.image = await this.app.fb.saveImage(
      event.target.files[0],
      "city_images/"
    );
  }

  async selectBannerImage(event) {
    this.bannerImage = await this.app.fb.saveImage(
      event.target.files[0],
      "banner_ads/"
    );
  }
}
